import { GraphQLError, GraphQLFormattedError } from 'graphql';

export class ValidationError extends GraphQLError {
    readonly fields: { [key: string]: string[] };

    constructor(error: GraphQLError | GraphQLFormattedError, message?: string) {
        super(!!message ? message : error.message, error instanceof GraphQLError ? error.nodes : undefined, error instanceof GraphQLError ? error.source : undefined, error instanceof GraphQLError ? error.positions : undefined, error instanceof GraphQLError ? error.path : undefined, error instanceof GraphQLError ? error.originalError : undefined, error.extensions);
        this.fields = (error.extensions?.fields as { [key: string]: string[] } | null) ?? {};
    }
}

export class AuthorizationError extends GraphQLError {
    constructor(error: GraphQLError | GraphQLFormattedError, message?: string) {
        super(!!message ? message : error.message, error instanceof GraphQLError ? error.nodes : undefined, error instanceof GraphQLError ? error.source : undefined, error instanceof GraphQLError ? error.positions : undefined, error instanceof GraphQLError ? error.path : undefined, error instanceof GraphQLError ? error.originalError : undefined, error.extensions);
    }
}

export class InternalServerError extends GraphQLError {
    constructor(error: GraphQLError | GraphQLFormattedError, message?: string) {
        super(!!message ? message : error.message, error instanceof GraphQLError ? error.nodes : undefined, error instanceof GraphQLError ? error.source : undefined, error instanceof GraphQLError ? error.positions : undefined, error instanceof GraphQLError ? error.path : undefined, error instanceof GraphQLError ? error.originalError : undefined, error.extensions);
    }
}
